import axios from "axios";
import store from "@/vuex/store";
const EMBED_URL = import.meta.env.VITE_EMBED_API_URL || 'https://embed.hibridstreaming.com';
const EMBED_BUNDLE_PATH = `${EMBED_URL}/static/bundles/`;

axios.defaults.headers.common['X-Embed-Version'] = 'VOD Embed v1.0';
axios.defaults.headers.common['X-Correlation-id'] = ''

async function loadBundle(player) {
    if(!store.getters.getPlayerData(player))
        await axios.get(`${EMBED_URL}/static/${player}`).then(res => {
            if (res.data)
                store.commit('setPlayer', {player, data:res.data})
            return res.data
        })
    let data = store.getters.getPlayerData(player);
    embedBundleScripts(data, 'embed-script')
    return true
}

function embedBundleScripts({scripts, player}, className) {
    scripts.css.forEach((item) => embedCSS(item, player, className));
    scripts.script.forEach((item) => embedJS(item, player, className));

    return true;
}

function embedCSS(path, player, className) {
    const element = createTagElement({
        tag: 'link',
        url: embedBundleUrl(path, player),
        className
    });
    appendElement(element)
}

function embedJS(path, player, className, url = undefined) {
    const element = createTagElement({
        tag: 'script',
        url: url || embedBundleUrl(path, player),
        className
    });
    appendElement(element)
}

function createTagElement(params) {
    const element = document.createElement(params.tag);

    if (params.tag === 'script') {
        element.setAttribute('type', 'text/javascript');
        element.setAttribute('src', params.url);
    } else {
        element.setAttribute('rel', 'stylesheet');
        element.setAttribute('href', params.url);
    }
    element.classList.add(params.className);
    // element.onload = () => console.log(`Bundle ${params.url} successfully loaded to DOM`);
    element.onerror = () => {
        throw new Error(`An error occur while embedding ${params.url} file.`)
    };
    return element;
}

const embedBundleUrl = (path, player) => `${EMBED_BUNDLE_PATH}${player}/${path.trim()}`;
const appendElement = (element) => {
    document
        .getElementsByTagName('head')
        .item(0)
        .appendChild(element)
};

function embedHibridPlayerScript(version = `v8.1.1` , bundleClassName = 'embed-script') {
    const element = document.createElement('script');

    element.setAttribute('type', 'text/javascript');
    element.setAttribute('src', `https://hibridplayer.com/l/${version}/hiplayerloader.min.js`);
    element.setAttribute('class', bundleClassName);
    appendElement(element)
    return true;
}

export {
    loadBundle,
    embedHibridPlayerScript
}

